import produce from 'immer';

import { Types, GerarRenachSemPcad } from './types';
import { ReducerAction } from '../../../../types';

// UTILS

export const INITIAL_STATE: GerarRenachSemPcad = {
	status: 0,
	data: null,
	requestData: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): GerarRenachSemPcad {
	return produce(state, draft => {
		switch (action.type) {
			case Types.GERAR_RENACH_SEM_PCAD_REQUEST: {
				break;
			}
			case Types.GERAR_RENACH_SEM_PCAD_SUCCESS: {
				draft.data = action.payload.response.data;
				draft.status = action.payload.response.status;
				draft.requestData = action.payload.request;
				break;
			}
			case Types.GERAR_RENACH_SEM_PCAD_FAILURE: {
				break;
			}

			default:
		}
	});
}
